import axios from 'axios';
const Apibaseurl = require('../constants/apibaseurl');
var apibaseurl = Apibaseurl.getAPiUrl();

// Create axios instance
const axiosInstance = axios.create({
  baseURL: apibaseurl,
  withCredentials: true, // ⭐ THIS IS THE KEY
});

// Request Interceptor - Add auth token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("NFT-Lux");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - Handle 401 globally
axiosInstance.interceptors.response.use(
  (response) => {
    // Return successful responses
    return response;
  },
  (error) => {
    // Check for 401 Unauthorized
    if (error.response && error.response.status === 401) {
      // Clear token and user data
      localStorage.removeItem("NFT-Lux");
      localStorage.clear(); // Or remove specific items

      // Redirect to login page
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

// Simplified request helpers using the configured instance
export const postRequest = (url, data) => {
  return axiosInstance
    .post(url, data)
    .then((res) => res.data);
};

export const postRequest1 = (url, data) => {
  return axiosInstance
    .post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

export const getRequest = (url) => {
  return axiosInstance
    .get(url)
    .then((res) => res.data);
};

export const getFullUrlRequest = (url) => {
  // For full URLs, use axios directly without baseURL
  const token = localStorage.getItem("NFT-Lux");
  const config = {
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios
    .get(url, config)
    .then((res) => res.data)
    .catch((error) => {
      // Handle 401 for full URL requests too
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("NFT-Lux");
        localStorage.clear();
        window.location.href = '/';
      }
      throw error;
    });
};

export default axiosInstance;

// import axios from 'axios';
// const Apibaseurl = require('../constants/apibaseurl');
// var apibaseurl = Apibaseurl.getAPiUrl();

// export const postRequest = (url, data) => {
//   //   const assestData = [];
//   const config = {
//     headers: {
//       Authorization: localStorage.getItem("NFT-Lux")
//         ? `Bearer ${localStorage.getItem("NFT-Lux")}`
//         : undefined,
//       'Content-Type': 'application/json;charset=UTF-8',
//       'Access-Control-Allow-Origin': '*',
//     },
//   };
//   return axios
//     .post(`${apibaseurl}${url}`, data, config)
//     .then((res) => res.data);
// };

// export const getRequest = (url, data) => {
//   //   const assestData = [];
//   const config = {
//     headers: {
//       Authorization: localStorage.getItem("NFT-Lux")
//         ? `Bearer ${localStorage.getItem("NFT-Lux")}`
//         : undefined,
//       'Content-Type': 'application/json;charset=UTF-8',
//       'Access-Control-Allow-Origin': '*',
//     },
//   };
//   return axios.get(`${apibaseurl}${url}`, config).then((res) => res.data);
// };
